module.exports = __webpack_public_path__ + "static/img/44.cee43f5b.png";